// extracted by mini-css-extract-plugin
export default {"panel":"InfoPanel_panel__IAWYf"};